import React from 'react';


const CIAMCallback = () => {
    return (
        <div>
            OK
        </div>
    );
};

export default CIAMCallback;
